const CustomTrampolineATC = (function () {
  function isCustomTrampoline(sku) {
    return CUSTOMTRAMPOLINES.includes(sku);
  }

  function hasItem(checkout, ctid) {
    let has_custom_trampoline = undefined;
    checkout.items.forEach((o, index) => {
      if (Object.keys(o.properties).length !== 0) {
        if (o.properties._ctid == ctid.value) {
          has_custom_trampoline = o;
          return false;
        }
      }
    });
    return has_custom_trampoline;
  }

  function addToCart(draftorder_id) {
    return new Promise(function (resolve, reject) {
      if (draftorder_id == undefined) {
        reject("false");
      }
      draftorder_id = atob(draftorder_id);

      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
          let data = JSON.parse(xmlHttp.response);
          if (data.status) {
            getCart()
              .then(function (checkout) {
                let lineItemsToAdd = [],
                  lineItemIdsToRemove = { updates: {} },
                  countCustomTrampoline = 0;
                data.draftorder.line_items.forEach(function (item, index, arr) {
                  let ctid = item.properties.find(
                    ({ name }) => name === "_ctid"
                  );

                  if (ctid !== undefined) {
                    let lineItem = { id: "" + item.variant_id, quantity: 1 };
                    if (isCustomTrampoline(item.sku)) {
                      lineItem["properties"] = {};
                      let has_custom_trampoline = hasItem(checkout, ctid);
                      if (has_custom_trampoline === undefined) {
                        lineItemsToAdd.push(lineItem);
                      }

                      item.properties.forEach(function (property, i, array) {
                        lineItem.properties[property.name] = property.value;
                      });
                    } else {
                      let acc = checkout.items.find((o) => {
                        return o.sku == item.sku;
                      });
                      if (acc === undefined) {
                        lineItemsToAdd.push(lineItem);
                      } else if (
                        [
                          "SP0280",
                          "G2JumboAnchorKit",
                          "SP0082",
                          "JumboAnchorKit",
                        ].includes(item.sku)
                      ) {
                        lineItemsToAdd.push(lineItem);
                        lineItemIdsToRemove.updates[acc.id] = 0;
                      }
                    }
                  }
                });

                lineItemsToAdd.forEach(function (item, index) {
                  if (item.properties !== undefined) {
                    countCustomTrampoline += item.quantity;
                  }
                });
                console.log("countCustomTrampoline", countCustomTrampoline);

                if (countCustomTrampoline > 0) {
                  lineItemsToAdd.push({
                    id: "" + customizationFeeID,
                    quantity: countCustomTrampoline,
                  });
                }

                if (lineItemsToAdd.length > 0) {
                  fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      items: lineItemsToAdd,
                    }),
                  })
                    .then((response) => {
                      return response.json();
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    })
                    .then((obj) => {
                      resolve(obj);
                      console.log(obj);
                      location.reload();
                    });
                } else {
                  resolve({ message: "Add to cart not needed!!!" });
                }
              })
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      };
      xmlHttp.open("GET", api3dCustomizer + "/item?id=" + draftorder_id, true);
      xmlHttp.send(null);
    });
  }

  getCart = function () {
    return fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  };

  return {
    addToCart: addToCart,
  };
})();
